import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  icon: '🛒',
  number: '01',
  title: 'Complete Your Purchase',
  description: 'Enter your payment method. The platform detects your country and automatically converts the price to your local currency.'
}, {
  icon: '📥',
  number: '02',
  title: 'Download Instantly',
  description: 'You get immediate access to all 10 PDF files. No waiting. No apps. No subscription required.'
}, {
  icon: '🌿',
  number: '03',
  title: 'Transform Your Practice',
  description: 'Start using the system in your very next consultation. Clinical structure, confidence, and professional precision from Day 1.'
}];
export function HowItWorks() {
  return <section className="w-full bg-off-white px-5 py-12 sm:py-20" data-id="element-124" data-mp="gt1p7w8eomqn">
      <div className="mx-auto max-w-5xl" data-id="element-125" data-mp="gr73ifpb8qli">
        <div className="mx-auto max-w-2xl text-center" data-id="element-126" data-mp="14iw048960189">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-slate sm:text-4xl" data-id="element-127" data-mp="14hb7io6eusd1">
            How Does It Work?
          </h2>
          <p className="mt-3 text-sm text-slate/70 sm:text-base" data-id="element-128" data-mp="2rmpm6j2d95xj">
            Simple, instant, and available from any country worldwide.
          </p>
        </div>

        <div className="mt-12 flex flex-col gap-8 md:flex-row md:gap-6" data-id="element-129" data-mp="31bh9uf0e942n">
          {steps.map((step, i) => <React.Fragment key={step.number} data-id="element-130" data-mp="2wkr6f7bj3bal" data-mpi={i}>
              <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.3
          }} transition={{
            duration: 0.45,
            delay: i * 0.1
          }} className="flex flex-1 flex-col items-center text-center" data-id="element-131" data-mp="2wjz99s2a95i7">
                <span className="flex h-16 w-16 items-center justify-center rounded-full border border-sage/30 bg-white text-3xl" data-id="element-132" data-mp="3faz2j5gt91ha">
                  {step.icon}
                </span>
                <span className="mt-4 font-serif-display text-2xl font-bold text-sage" data-id="element-133" data-mp="1kxhcnbsxnsj3">
                  {step.number}
                </span>
                <h3 className="mt-2 text-lg font-bold text-slate" data-id="element-134" data-mp="3l11q0y5ej0sm">{step.title}</h3>
                <p className="mt-3 max-w-xs text-sm leading-relaxed text-slate/70" data-id="element-135" data-mp="3pzlbyyjzwckz">
                  {step.description}
                </p>
              </motion.div>
              {i < steps.length - 1 && <div className="mx-auto h-8 w-px bg-sage/30 md:hidden" aria-hidden="true" data-id="element-136" data-mp="2u452dj0tmuz" />}
            </React.Fragment>)}
        </div>
      </div>
    </section>;
}